/** Formats a timestamp as a French relative time string. */
export function timeAgo(ts: number | string): string {
  const now = Date.now();
  const t = typeof ts === 'string' ? new Date(ts).getTime() : ts;
  const diff = Math.floor((now - t) / 1000);
  if (diff < 60) return "À l'instant";
  if (diff < 3600) return `Il y a ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `Il y a ${Math.floor(diff / 3600)} h`;
  if (diff < 172800) return 'Hier';
  return new Date(t).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short' });
}

/** Returns true if a mission's status is archived. */
export function isArchivedMission(m: { status?: string }): boolean {
  return m.status === 'Archivé' || m.status === 'Archive' || m.status === 'Archivée';
}
